import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
interface AgentWiseReportProps {
  dateRange: {
    from: string;
    to: string;
  };
}
const AgentWiseReport: React.FC<AgentWiseReportProps> = ({
  dateRange
}) => {
  // Mock data for the report
  const agentData = [{
    agent: 'Al Ansari Exchange',
    transactions: 185,
    amount: 925000
  }, {
    agent: 'UAE Exchange',
    transactions: 150,
    amount: 750000
  }, {
    agent: 'Western Union',
    transactions: 130,
    amount: 650000
  }, {
    agent: 'MoneyGram',
    transactions: 110,
    amount: 550000
  }, {
    agent: 'Ria Money Transfer',
    transactions: 90,
    amount: 450000
  }, {
    agent: 'Other Agents',
    transactions: 110,
    amount: 550000
  }];
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };
  return <div data-id="element-2235">
      <div className="mb-4 p-3 bg-blue-50 border border-blue-100 rounded-md" data-id="element-2236">
        <h3 className="text-sm font-medium text-blue-800" data-id="element-2237">Report Parameters</h3>
        <p className="text-xs text-blue-600 mt-1" data-id="element-2238">
          Date Range: {dateRange.from} to {dateRange.to}
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-2239">
        <div style={{
        height: 300
      }} data-id="element-2240">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2241">
            Transactions by Agent
          </h3>
          <ResponsiveContainer width="100%" height="100%" data-id="element-2242">
            <PieChart data-id="element-2243">
              <Pie data={agentData} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="transactions" label={({
              name,
              percent
            }) => `${name} ${(percent * 100).toFixed(0)}%`} data-id="element-2244">
                {agentData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-2245" />)}
              </Pie>
              <Tooltip formatter={value => [`${value} transactions`, 'Transactions']} data-id="element-2246" />
              <Legend data-id="element-2247" />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div style={{
        height: 300
      }} data-id="element-2248">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2249">
            Amount by Agent
          </h3>
          <ResponsiveContainer width="100%" height="100%" data-id="element-2250">
            <PieChart data-id="element-2251">
              <Pie data={agentData} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="amount" label={({
              name,
              percent
            }) => `${name} ${(percent * 100).toFixed(0)}%`} data-id="element-2252">
                {agentData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-2253" />)}
              </Pie>
              <Tooltip formatter={value => [formatCurrency(Number(value)), 'Amount']} data-id="element-2254" />
              <Legend data-id="element-2255" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-2256">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-2257">
          <thead className="bg-gray-50" data-id="element-2258">
            <tr data-id="element-2259">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2260">
                Agent
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2261">
                Transactions
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2262">
                Amount
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2263">
                Percentage (Amount)
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-2264">
            {agentData.map(item => <tr key={item.agent} className="hover:bg-gray-50" data-id="element-2265">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2266">
                  {item.agent}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2267">
                  {item.transactions}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2268">
                  {formatCurrency(item.amount)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2269">
                  {(item.amount / agentData.reduce((sum, data) => sum + data.amount, 0) * 100).toFixed(2)}
                  %
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-md" data-id="element-2270">
        <div className="flex justify-between items-center" data-id="element-2271">
          <span className="text-sm font-medium text-gray-700" data-id="element-2272">
            Total Transactions:{' '}
            {agentData.reduce((sum, data) => sum + data.transactions, 0)}
          </span>
          <span className="text-sm font-medium text-gray-700" data-id="element-2273">
            Total Amount:{' '}
            {formatCurrency(agentData.reduce((sum, data) => sum + data.amount, 0))}
          </span>
        </div>
      </div>
    </div>;
};
export default AgentWiseReport;